var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2552_10385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 13.125C12.211 13.125 13.1251 12.2109 13.1251 11.0833C13.1251 9.95575 12.211 9.04166 11.0834 9.04166C9.95583 9.04166 9.04175 9.95575 9.04175 11.0833C9.04175 12.2109 9.95583 13.125 11.0834 13.125Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 4.95833C4.04425 4.95833 4.95833 4.04425 4.95833 2.91667C4.95833 1.78909 4.04425 0.875 2.91667 0.875C1.78909 0.875 0.875 1.78909 0.875 2.91667C0.875 4.04425 1.78909 4.95833 2.91667 4.95833Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68066 2.91666H9.72233C10.0833 2.91666 10.4295 3.06007 10.6848 3.31532C10.94 3.57058 11.0834 3.91679 11.0834 4.27778V9.04166",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 4.95834V13.125",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2552_10385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandIcon);
export default __webpack_public_path__ + "static/media/demand_icon.98f7381e921274d25b8916fd2fc24857.svg";
export { ForwardRef as ReactComponent };